export type NowPrimaryAction = {
	label: 'Открыть ход' | 'Создать сценарий' | 'Добавить сессии' | 'Запустить';
	to: '/console' | '/scenarios/new' | '/send?mode=batch';
};

function scenarioStepSatisfied(scenarioCount: number, presetsEnabled: boolean): boolean {
	return !presetsEnabled || scenarioCount > 0;
}

export function resolveNowPrimaryAction(input: {
	consoleRunning: boolean;
	autoRunning: boolean;
	scenarioCount: number;
	readyAccountCount: number;
	presetsEnabled?: boolean;
}): NowPrimaryAction {
	const presetsEnabled = input.presetsEnabled ?? true;
	if (input.consoleRunning || input.autoRunning) {
		return { label: 'Открыть ход', to: '/console' };
	}
	if (!scenarioStepSatisfied(input.scenarioCount, presetsEnabled)) {
		return { label: 'Создать сценарий', to: '/scenarios/new' };
	}
	if (input.readyAccountCount <= 0) {
		return { label: 'Добавить сессии', to: '/send?mode=batch' };
	}
	return { label: 'Запустить', to: '/send?mode=batch' };
}

export function resolveNowSentence(input: {
	consoleRunning: boolean;
	autoRunning: boolean;
	scenarioCount: number;
	readyAccountCount: number;
	runCount: number;
	presetsEnabled?: boolean;
}): string {
	const presetsEnabled = input.presetsEnabled ?? true;
	if (input.consoleRunning) return 'Рассылка идёт';
	if (input.autoRunning) return 'Авторассылка включена';
	if (input.readyAccountCount <= 0 && input.runCount <= 0) {
		if (!presetsEnabled) return 'Добавьте сессии';
		if (input.scenarioCount <= 0) return 'Начните со сценария';
	}
	return 'Сейчас тихо';
}

export function isNowFirstVisit(input: {
	scenarioCount: number;
	readyAccountCount: number;
	runCount: number;
	presetsEnabled?: boolean;
}): boolean {
	const presetsEnabled = input.presetsEnabled ?? true;
	if (input.readyAccountCount > 0 || input.runCount > 0) return false;
	if (!presetsEnabled) return true;
	return input.scenarioCount <= 0;
}

export function formatNowCount(value: number | null | undefined): string {
	if (value == null || Number.isNaN(value)) return '—';
	return String(value);
}

export function nowQueueCount(summary: { accountsTotal: number; accountsProcessed: number } | null): number | null {
	if (!summary) return null;
	return Math.max(0, summary.accountsTotal - summary.accountsProcessed);
}

export function resolveNowAttention(input: { queueFailed: number }): { label: string; to: string } | null {
	if (input.queueFailed > 0) {
		return { label: 'В авторассылке есть ошибки', to: '/send?mode=auto' };
	}
	return null;
}

export function readHttpStatus(error: unknown): number | null {
	if (typeof error !== 'object' || error === null || !('response' in error)) return null;
	const response = (error as { response?: unknown }).response;
	if (typeof response !== 'object' || response === null || !('status' in response)) return null;
	const status = (response as { status?: unknown }).status;
	return typeof status === 'number' ? status : null;
}

/** Выключенный флаг отвечает 403 и не должен ронять хаб. Сеть и прочие отказы — должны. */
export function isNowOptionalFetchFatal(input: {
	enabled: boolean;
	rejected: boolean;
	httpStatus: number | null;
}): boolean {
	if (!input.enabled || !input.rejected) return false;
	return input.httpStatus !== 403;
}
